import { makeStyles, tokens } from "@fluentui/react-components";

export const useStyle = makeStyles({
	downloadAttachmentButton: {
		color: `${tokens.colorNeutralForeground2} !important`,

		"&:hover": {
			backgroundColor: tokens.colorSubtleBackgroundHover,
			color: `${tokens.colorNeutralForeground2BrandHover} !important`,
		},
	},
});
